
import { supabase } from '@/integrations/supabase/client';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'sonner';

/**
 * Uploads a logo image to Supabase storage and returns the public URL
 * @param imageDataUrl - Base64 encoded image data URL
 * @param userId - User ID to create a unique path
 * @returns The public URL of the uploaded image or null if upload fails
 */
export async function uploadLogo(imageDataUrl: string, userId: string): Promise<string | null> {
  try {
    // Extract the base64 part from the data URL
    const base64Data = imageDataUrl.split(',')[1];
    
    if (!base64Data) {
      console.error('Invalid image data URL');
      return null;
    }

    // Convert base64 to Blob
    const blob = await fetch(imageDataUrl).then(res => res.blob());
    
    // Generate a unique file name
    const fileName = `${userId}-${uuidv4()}.png`;
    const filePath = `${userId}/${fileName}`;

    // Upload to Supabase Storage
    const { data, error } = await supabase
      .storage
      .from('brand_logos')
      .upload(filePath, blob, {
        contentType: 'image/png',
        upsert: true
      });

    if (error) {
      console.error('Error uploading logo:', error);
      toast.error('Failed to upload logo');
      return null;
    }

    // Get the public URL
    const { data: { publicUrl } } = supabase
      .storage
      .from('brand_logos')
      .getPublicUrl(filePath);

    console.log('Logo uploaded successfully:', publicUrl);
    return publicUrl;
  } catch (error) {
    console.error('Error in uploadLogo:', error);
    toast.error('Failed to upload logo');
    return null;
  }
}
